import {
  AccountCircle,
  Logout,
  Menu as MenuIcon,
  Settings,
} from "@mui/icons-material";
import {
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuList } from "../../enums/menu-lis";
import { useGetMyProfileHook } from "../../../features/profile/hooks/profile.hook";

export interface NavbarProps {
  onMenuClick?: () => void;
}

export const NavbarComponent: React.FC<NavbarProps> = ({ onMenuClick }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { data: profile } = useGetMyProfileHook();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action: string) => {
    handleClose();
    if (action === "Profile") {
      navigate(`/${MenuList.PROFILE}`);
      return;
    }
    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: { xs: "8px 10px", sm: "10px 14px" },
      }}
    >
      <IconButton
        onClick={onMenuClick}
        size="small"
        sx={{ display: { xs: "inline-flex", md: "none" } }}
      >
        <MenuIcon fontSize="small" />
      </IconButton>

      <Box sx={{ flex: 1 }} />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mr: 1.5 }}>
        <Typography
          sx={{
            fontWeight: 600,
            color: "#000",
            fontSize: "13px",
            display: { xs: "none", sm: "block" },
          }}
        >
          {profile?.fullName || ""}
        </Typography>
      </Box>

      <IconButton
        onClick={handleClick}
        sx={{
          padding: 0,
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Avatar
          src={profile?.avatar || ""}
          alt={profile?.fullName || ""}
          sx={{
            width: 36,
            height: 36,
            border: "2px solid #f0f0f0",
            cursor: "pointer",
            "&:hover": {
              border: "2px solid #1976d2",
            },
          }}
        />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1,
            minWidth: 170,
            "& .MuiMenuItem-root": {
              px: 1.5,
              py: 1,
              fontSize: "13px",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={() => handleMenuItemClick("Profile")}>
          <ListItemText>Profile</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => handleMenuItemClick("Account")}>
          <ListItemIcon>
            <AccountCircle fontSize="small" />
          </ListItemIcon>
          <ListItemText>My Account</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => handleMenuItemClick("Settings")}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </MenuItem>

        <Divider />

        <MenuItem onClick={() => handleMenuItemClick("Logout")}>
          <ListItemIcon>
            <Logout fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};
